import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem;
  text-align: center;
`;
